<template>
    <div class="w-full">
      <div class="filter-section mb-2">
        <h3 class="text-sm font-medium text-gray-900 mb-0">Brands</h3>
        <div class="flex space-x-1 overflow-x-auto py-0 hide-scrollbar">
          <button
            v-for="brand in brands"
            :key="brand"
            @click="toggleBrand(brand)"
            class="flex-shrink-0 px-2 py-1 rounded-full border-2 transition-colors"
            :class="[
              selectedBrands.includes(brand)
                ? 'border-blue-500 bg-blue-50 text-blue-600'
                : 'border-gray-200 hover:border-gray-300 text-gray-600'
            ]"
          >
            {{ brand }}
          </button>
        </div>
      </div>
  
      <div class="filter-section">
        <h3 class="text-sm font-medium text-gray-900 mb-0">Types</h3>
        <div class="flex space-x-3 overflow-x-auto py-2 hide-scrollbar">
          <button
            v-for="type in types"
            :key="type"
            @click="toggleType(type)"
            class="flex-shrink-0 px-2 py-1 rounded-full border-2 transition-colors"
            :class="[
              selectedTypes.includes(type)
                ? 'border-blue-500 bg-blue-50 text-blue-600'
                : 'border-gray-200 hover:border-gray-300 text-gray-600'
            ]"
          >
            {{ type }}
          </button>
        </div>
      </div>

      <div class="filter-section">
        <h3 class="text-sm font-medium text-gray-900 mb-0">Kategori</h3>
        <div class="flex space-x-3 overflow-x-auto py-2 hide-scrollbar">
          <button
            v-for="category in categories"
            :key="category"
            @click="toggleCategory(category)"
            class="flex-shrink-0 px-2 py-1 rounded-full border-2 transition-colors"
            :class="[
              selectedCategories.includes(category)
                ? 'border-blue-500 bg-blue-50 text-blue-600'
                : 'border-gray-200 hover:border-gray-300 text-gray-600'
            ]"
          >
            {{ category }}
          </button>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'HorizontalFilter',
    props: {
      brands: {
        type: Array,
        required: true
      },
      types: {
        type: Array,
        required: true
      },
      categories: {
      type: Array,
      required: true
    }
    },
    data() {
      return {
        selectedBrands: [],
        selectedTypes: [],
        selectedCategories: []
      }
    },
    methods: {
      toggleBrand(brand) {
        const index = this.selectedBrands.indexOf(brand)
        if (index === -1) {
          this.selectedBrands.push(brand)
        } else {
          this.selectedBrands.splice(index, 1)
        }
        this.emitFilterChange()
      },
      toggleType(type) {
        const index = this.selectedTypes.indexOf(type)
        if (index === -1) {
          this.selectedTypes.push(type)
        } else {
          this.selectedTypes.splice(index, 1)
        }
        this.emitFilterChange()
      },
      toggleCategory(category) {
      const index = this.selectedCategories.indexOf(category)
      if (index === -1) {
        this.selectedCategories.push(category)
      } else {
        this.selectedCategories.splice(index, 1)
      }
        this.emitFilterChange()
      },
      emitFilterChange() {
        this.$emit('filter', {
          brands: this.selectedBrands,
          types: this.selectedTypes,
          categories: this.selectedCategories
        })
      }
    }
  }
  </script>
  
  <style scoped>
  .hide-scrollbar {
    scrollbar-width: none;
    -ms-overflow-style: none;
  }
  
  .hide-scrollbar::-webkit-scrollbar {
    display: none;
  }
  
  .filter-section {
    padding: 0 1rem;
  }
  </style>